<style lang="less" scoped>
  @import "../../../../style/theme.less";

  .inputs-container {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;

    .label {
      line-height: 35px;
      padding: 0;
      margin: 0;
      font-weight: bold;
      transition: color .1s @ease-in-out;
      color: @primary-color;

      &.disagree {
        text-align: left;
        padding-right: 20px;
        word-wrap: normal;
      }

      &.agree {
        text-align: right;
        padding-left: 20px;
        word-wrap: normal;
      }
    }
    .inputs {
      align-items: center;
    }
  }

  h4 {
    transition: color .1s @ease-in-out;
  }
  .inputs-container.done .label, h4.done {
    color: darken(@border-color-base, 10%);
  }
</style>

<template>
  <div>
    <h4 :class="done ? 'done' : ''">{{ questionText }}</h4>

    <a-row
      class="inputs-container"
      :class="done ? 'done' : ''"
      type="flex"
    >
      <a-col flex="90px" v-if="!mobileLabels">
        <span class="label disagree">Disagree</span>
      </a-col>

      <a-col flex="auto">
        <a-row class="inputs" type="flex">
          <a-col flex="auto" v-for="n in 5" :key="n">
            <question-input
              :value="n"
              :active="active === n"
              :done="done"
              :tooltip="tooltips[n]"
              @click="() => setActive(n)"
            />
          </a-col>
        </a-row>
      </a-col>

      <a-col flex="90px" v-if="!mobileLabels">
        <span class="label agree">Agree</span>
      </a-col>
    </a-row>

    <a-row v-if="mobileLabels" type="flex" class="inputs-container">
      <a-col flex="90px" v-if="mobileLabels">
        <span class="label disagree">Disagree</span>
      </a-col>

      <a-col flex="auto" />

      <a-col flex="90px" v-if="mobileLabels">
        <span class="label agree">Agree</span>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import questionInput from './_input';

export default {
  name: 'question',

  data: () => ({
    active: undefined,
    done: false,

    mobileLabels: false,

    tooltips: {
      1: 'Fully Disagree',
      2: 'Somewhat Disagree',
      3: 'Neither',
      4: 'Somewhat Agree',
      5: 'Fully Agree',
    },

    resizeListener: null,
  }),

  props: {
    questionText: String,
    startValue: Number,
    neverDone: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    questionInput,
  },

  mounted() {
    if (this.startValue) {
      this.active = this.startValue;
    }

    this.onResize();

    this.resizeListener = window.addEventListener('resize', this.onResize);
  },

  breforeDestroy() {
    window.removeEventListener('resize', this.resizeListener);
  },

  methods: {
    setActive(value) {
      this.active = value;
      this.$emit('change', value);
      this.done = !this.neverDone;
    },

    onResize() {
      this.mobileLabels = window.innerWidth < 400;
    },
  },
};
</script>
